import { Shield, Sparkles, Receipt, BadgeCheck, Handshake } from 'lucide-react';

const ICON_PROPS = {
  width: 22,
  height: 22,
  strokeWidth: 2,
  'aria-hidden': true,
};

const Why = () => {
  return (
    <section className="why" id="why" aria-label="Why choose PaveMend">
      <div className="container">
        <div className="why__header">
          <h2 className="why__title">
            Why choose <em>PaveMend?</em>
          </h2>
          <p className="why__intro">
            We're a local <strong>London</strong> team, not a faceless national
            contractor. Every driveway, patio, deck and fence we lay is treated
            with the same care we'd give our own home — and we back every job
            with a full satisfaction <strong>guarantee</strong>.
          </p>
        </div>

        <div className="why__features">
          <div className="why__feature">
            <div className="why__feature-icon" aria-hidden="true">
              <Shield {...ICON_PROPS} />
            </div>
            <div>
              <p className="why__feature-title">Fully Insured</p>
              <p className="why__feature-text">
                All work is carried out by accredited tradespeople, fully
                insured for your total peace of mind.
              </p>
            </div>
          </div>
          <div className="why__feature">
            <div className="why__feature-icon" aria-hidden="true">
              <Sparkles {...ICON_PROPS} />
            </div>
            <div>
              <p className="why__feature-title">No Mess, No Hassle</p>
              <p className="why__feature-text">
                We keep a tidy, respectful site every single day. Your property
                is left clean at the end of each shift — no excuses.
              </p>
            </div>
          </div>
          <div className="why__feature">
            <div className="why__feature-icon" aria-hidden="true">
              <Receipt {...ICON_PROPS} />
            </div>
            <div>
              <p className="why__feature-title">Honest Pricing</p>
              <p className="why__feature-text">
                Clear, itemised quotes before a single stone is moved. No
                last-minute add-ons, no vague estimates — the price we quote is
                the price you pay.
              </p>
            </div>
          </div>
        </div>

        <div className="why__features">
          <div className="why__feature">
            <div className="why__feature-icon" aria-hidden="true">
              <BadgeCheck {...ICON_PROPS} />
            </div>
            <div>
              <p className="why__feature-title">3-Year Workmanship Guarantee</p>
              <p className="why__feature-text">
                We stand behind everything we install. If anything isn't right
                within three years, we come back and fix it — no quibbling.
              </p>
            </div>
          </div>
          <div className="why__feature">
            <div className="why__feature-icon" aria-hidden="true">
              <Handshake {...ICON_PROPS} />
            </div>
            <div>
              <p className="why__feature-title">Free Consultations</p>
              <p className="why__feature-text">
                We come to you — anywhere in South East London — take a proper
                look at the space and give honest advice. No pressure, no
                commitment required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;
